import { render, staticRenderFns } from "./SectionBody.vue?vue&type=template&id=24cf75b2&"
import script from "./SectionBody.vue?vue&type=script&lang=ts&"
export * from "./SectionBody.vue?vue&type=script&lang=ts&"
import style0 from "./SectionBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports